import '@babel/polyfill';
import SlideUpDown from 'vue-slide-up-down';
import * as moment from 'moment';
import VueTimeago from 'vue-timeago/dist/vue-timeago';
import VTooltip from 'v-tooltip';
import VueSweetalert2 from 'vue-sweetalert2';
import Dropdown from 'hsy-vue-dropdown';
import { filter } from 'lodash';
import Vuex from 'vuex';
import store from './store/index';
import VueLocalStorage from 'vue-localstorage';
import VueRouter from 'vue-router';
import Vue2Filters from 'vue2-filters'
import vueFilterPrettyBytes from 'vue-filter-pretty-bytes';
import vueShortkey from 'vue-shortkey';
import Vue from 'vue';
require('./bootstrap');
import BootstrapVue from 'bootstrap-vue';
import "./vee-validate";
import * as Sentry from "@sentry/vue";
import iframeResize from 'iframe-resizer/js/iframeResizer';

if (process.env.NODE_ENV !== 'development' && process.env.MIX_SENTRY_DSN) {
    Sentry.init({
        Vue,
        dsn: process.env.MIX_SENTRY_DSN,
        environment: process.env.MIX_SENTRY_ENVIRONMENT,
        release: window.versionInfo && window.versionInfo.buildNumber,
        initialScope: {
            tags: { app: "insite" },
            user: window.userInfo,
        },
    });
}

window.Vue = Vue;
moment.locale('nl');
Vue.prototype.moment = moment;
Vue.prototype._ = {
    filter: filter
};
Vue.prototype.wizardUrl = process.env.MIX_WIZARD_URL;
Vue.prototype.apiUrl = process.env.MIX_API_URL;

Vue.use(Vuex);
Vue.use(VueLocalStorage);

Vue.component('passport-clients', require('./components/passport/Clients').default);
Vue.component('passport-authorized-clients', require('./components/passport/AuthorizedClients').default);
Vue.component('passport-personal-access-tokens', require('./components/passport/PersonalAccessTokens').default);
Vue.component('formdata', require('./components/insite/formData').default);
Vue.component('formdata-display', require('./components/insite/formDataDisplay').default);
Vue.component('vue-slide-up-down', SlideUpDown);
Vue.component('pagination', require('laravel-vue-pagination'));

Vue.use(Dropdown);
Vue.use(VueSweetalert2);
Vue.use(BootstrapVue);
Vue.use(VTooltip);
Vue.use(VueRouter);
Vue.use(Vue2Filters);
Vue.use(vueFilterPrettyBytes)
Vue.use(vueShortkey, { prevent: ['input', 'textarea'] })
Vue.use(VueTimeago, {
    name: 'timeago',
    locale: 'nl-NL',
    locales: {
        'nl-NL': require('vue-timeago/locales/nl-NL.json')
    }
});

Vue.prototype.$errorMessage = (error) => {
    if(error && error.hasOwnProperty('response') && error.response.hasOwnProperty('data') && error.response.data.hasOwnProperty('message')) {
        let errors = [error.response.data.message];

        if(error.response.data.hasOwnProperty('errors')) {
            for(let key in error.response.data.errors) {
                if(!error.response.data.errors.hasOwnProperty(key)) {
                    continue;
                }

                errors.push(error.response.data.errors[key].join(', '));
            }
        }

        return errors.join("<br />");
    } else {
        return error;
    }
};

Vue.directive('resize', {
    bind: function(el, { value = {} }) {
        el.addEventListener('load', () => iframeResize(value, el));
    },
    unbind: function (el) {
        el.iFrameResizer.removeListeners();
    }
});

const routes = [
    {
        name: 'home',
        path: '/insite',
        component: require('./components/insite/home').default,
        meta: {
            breadcrumb: 'Leads'
        },
        children: [
            {
                name: 'lead.details',
                path: 'lead/:leadId',
                component: require('./components/insite/leads/detail').default,
                meta: {
                    breadcrumb(routeParams) { return 'Lead #' + routeParams.leadId }
                },
            },
            {
                name: 'lead.create',
                path: 'lead/create',
                component: require('./components/insite/leads/detail').default,
                meta: {
                    breadcrumb: 'Lead aanmaken'
                },
            },
            {
                name: 'nv-lead.create',
                path: 'nv-lead/create',
                component: require('./components/insite/leads/nvLead').default,
                meta: {
                    breadcrumb: 'NV Lead aanmaken'
                }
            },
            {
                name: 'nv-lead.details',
                path: 'nv-lead/:leadId',
                component: require('./components/insite/leads/nvLead').default,
                meta: {
                    breadcrumb(routeParams) { return 'NV Lead #' + routeParams.leadId }
                },
            }
        ]
    }
];

const router = new VueRouter({
    mode: 'history',
    routes: routes
});

function hasQueryParams(route) {
    return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
    if (!hasQueryParams(to) && hasQueryParams(from)) {
        next({ name: to.name, params: to.params, query: from.query });
    } else {
        next();
    }

    // Fix for getting the nv-lead details iframe auth working inside the afas iframe.
    // See Jira issue: NVA-84
    // if (from.name === 'nv-lead.details' && to.name === 'home') {
    //     window.location.reload();
    // }
});

const app = new Vue({
    store,
    router
}).$mount('#app');

app.$store.commit('settingsStore/settings', {
    defaultPrioId: process.env.MIX_DEFAULT_LEAD_PRIO_ID,
    openStatusId: process.env.MIX_OPEN_STATUS_ID,
    awaitingCustomerStatusId: process.env.MIX_AWAITING_CUSTOMER_STATUS_ID,
    offerStatusId: process.env.MIX_OFFER_STATUS_ID || 13
});

window.onerror = function() {
    if(window.hotjarEnabled) {
        hj('tagRecording', ['window.onerror']);
    }
};

if (!Math.trunc) {
    Math.trunc = function(v) {
        v = +v;
        return (v - v % 1)   ||   (!isFinite(v) || v === 0 ? v : v < 0 ? -0 : 0);
    };
}